import PropTypes from 'prop-types';
import React from 'react';
import { FDStack } from '@facet-wealth/design';
import ToggleButton from 'Packages/FacetDesign/Components/Experimental/ToggleButton';
import { dataAttrs } from 'Helpers/Testing';

const DesktopOwnerFilters = ({ handleChange, currentVal, ownerOptions }) => {
  return (
    <FDStack direction={'row'} spacing={1} {...dataAttrs('owner-filters')}>
      <ToggleButton
        option={{
          id: undefined,
          prompt: 'View all',
        }}
        value={currentVal}
        onChange={() => handleChange(undefined)}
      />
      { ownerOptions.map((option) => (<ToggleButton
        key={option.id()}
        option={{
          id: option.attr('id'),
          prompt: option.attr('prompt'),
        }}
        value={currentVal}
        onChange={(value) => handleChange(value)}
      />))}
    </FDStack>
  );
};

DesktopOwnerFilters.defaultProps = {};

DesktopOwnerFilters.propTypes = {
  handleChange: PropTypes.func.isRequired,
  currentVal: PropTypes.string.isRequired,
  ownerOptions: PropTypes.object.isRequired,
};

export { DesktopOwnerFilters };
